import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { DesktopWarehouse } from '@/features/warehouse/DesktopWarehouse';
import { MobileWarehouse } from '@/features/warehouse/mobile/MobileWarehouse';

/**
 * Le giacenze: la pagina operativa, quella che si apre venti volte al giorno.
 *
 * Sotto i 768px si monta un componente **diverso**, non la stessa pagina ristretta: qui il caso d'uso
 * mobile è quello principale — il magazziniere in piedi fra gli scaffali — e una tabella a sette
 * colonne che scorre di lato non è la stessa cosa.
 */
export const Route = createFileRoute('/_app/warehouse/')({ component: Stocks });

function Stocks() {
  return useIsMobileShell() ? <MobileWarehouse /> : <DesktopWarehouse />;
}
